export default function back2top (offset) {
  const backToTop = document.getElementById('back2top')
  const scrollOffset = offset || 60

  if (backToTop) {
    scrollCallback()
    window.addEventListener('scroll', scrollCallback)

    backToTop.addEventListener('click', function(e) {
      e.preventDefault()
      const targetId = this.getAttribute('data-target')
      const target = document.getElementById(targetId) || document.body
      target.scrollIntoView({
        behavior: 'smooth'
      })
      target.setAttribute('tabindex', '-1')
      target.focus()

      function removeTabIndex(){
        target.removeAttribute('tabindex')
        target.removeEventListener('focus', removeTabIndex)
      }

      target.addEventListener('focus', removeTabIndex)
    })
  }
  function scrollCallback() {
    if (window.scrollY > scrollOffset) {
      backToTop.style.display = 'block'
    } else {
      backToTop.style.display = 'none'
    }
  }
}
